import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  EventEmitter,
  Output,
  Input,
  ViewEncapsulation,
  // ChangeDetectorRef,
  // ChangeDetectionStrategy
} from "@angular/core";
import {
  MatTableDataSource,
  MatDialog,
  MatPaginator,
  MatSort,
  Sort,
  MatSelect,
} from "@angular/material";
import { MatOption } from "@angular/material/core";
import { Toast, ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../shared/service/user.service";
import { OnboardingHRDetail } from "../../shared/models/OnboardingHRDetail";
import { EmployeeService } from "../../shared/service/employee.service";
import { HRStatus, Offboarding } from "../../shared/models/Offboarding";
import { OffbaordingFeedbackTypeClass } from "../../shared/models/OffbaordingFeedbackTypeClass";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { EmployeeModel } from "../../shared/models/employee.model";
import { PeopleManagerModel } from "../../shared/models/peoplemanagermodel";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import * as xlsx from "xlsx";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-offboarding-employee-list",
  templateUrl: "./offboarding-employee-list.component.html",
  styleUrls: ["./offboarding-employee-list.component.css"],
  // changeDetection: ChangeDetectionStrategy.Default
  // encapsulation: ViewEncapsulation.None
})
export class OffboardingEmployeeListComponent implements OnInit {
  dataSourceFTE: MatTableDataSource<Offboarding>;
  dataSource: MatTableDataSource<Offboarding>;
  dataSourceQueue: MatTableDataSource<Offboarding>;
  dataSourceHR: MatTableDataSource<Offboarding>;
  dataSourceFinance: MatTableDataSource<Offboarding>;
  dataSourceComplete: MatTableDataSource<Offboarding>;

  error: string;
  offboarding: Offboarding[] = [];
  offboardingHR: Offboarding[] = [];
  offboardingFinance: Offboarding[] = [];
  offboardingFinal: Offboarding[] = [];
  pmList: any[] = [];
  pmcodeList: any;
  displayList: any[] = [];
  test: any[] = [];
  empCode: any;
  firstName: any;
  feedbackType: any;
  offboardingEmpListMyApproval: Offboarding[] = [];
  offboardingEmpListApproved: Offboarding[] = [];
  offboardingEmpListRejected: Offboarding[] = [];
  offboardingEmpListInWard: Offboarding[] = [];

  oldOffboardingEmpListMyApproval: Offboarding[] = [];
  oldOffboardingEmpListApproved: Offboarding[] = [];
  oldOffboardingEmpListRejected: Offboarding[] = [];
  oldOffboardingEmpListInWard: Offboarding[] = [];
  isOpen: boolean = false;

  allOffboardingEmployeesListForHr: [];
  offboardingdetails: Offboarding;
  checklist: OffbaordingFeedbackTypeClass[] = [];
  code: any;
  permission: any;
  editEnable: boolean = false;
  deleteEnable: boolean = false;
  designation: string;
  codeExistsinPMList: boolean = false;
  contactList: any[] = [];
  email: any;
  offboardingboolean: boolean;
  employeeStatus: string;
  department: string;
  employeecodelist: any[] = [];
  HRfbRes: string;
  financeRes: string;
  mailexitsIT: boolean;
  mailexitsAdmin: boolean;
  result: any;
  disableFbIcon: boolean;
  loadData: Offboarding;
  ITAdminWithPM: any[] = [];
  FinanceWithPM: any[] = [];
  deptWithPM: any[] = [];
  deptWithoutPM: any[] = [];
  loader: boolean;
  pmCodeClearanceList: any[] = [];
  offboardingDeptCompleted: Offboarding[] = [];
  pmInCompleteList: any;
  isPMList: any;
  PMList: any;
  completedcheckList: OffbaordingFeedbackTypeClass[] = [];
  isPMtrue: boolean;
  isPM: boolean = true;
  firstTabHide: boolean;
  isPMHR: boolean;
  onlyHR: boolean;
  isInWardTrue: boolean;
  showEmpFeedback: boolean;
  showEmptyMessage: string;
  emptyRecordboolean: boolean;
  showEmptyMessageFinance: string;
  emptyRecordbooleanFinance: boolean;
  showEmptyMessageHR: string;
  emptyRecordbooleanHR: boolean;
  showEmptyMessageComplete: string;
  emptyRecordbooleanComplete: boolean;
  FinancialYears: any;
  finYear: string;
  excelDetails: Offboarding[];
  totalCount: number = 0;
  TabIndex: number = 0;
  originalDataSourceAll: Offboarding[] = [];
  HrQueueDetails: Offboarding[];
  index: number;
  fromRouting = false;

  lstData: any;
  totalItems: number;
  search: any;
  inClearanceSearch: any;

  resgntypeResult: any;
  statusResult: any;
  DateResult: any;
  name: string;

  selectedAllTypes = false;
  selectedAllStatus = false;
  selectedAllDates = false;

  managerTabIdx: number = 0;
  searchInputValue: string = "";
  offboardingId: number;
  selectedPO: any;
  selectedMasterIds: any;
  finalShowCC: any;
  hrStatus = HRStatus;
  count: number = 0;
  tabName: string = "";
  inClearanceData: any = [];
  dataSourceHR_bkp: any = [];

  selectedMonths: string[] = [];

  datePipe: DatePipe;

  statusList: any[] = [
    { value: "Saved", viewValue: "Saved", name: "Saved", checked: true },
    {
      value: "Submitted",
      viewValue: "Submitted",
      name: "Submitted",
      checked: true,
    },
    {
      value: "Approved",
      viewValue: "Approved",
      name: "Approved",
      checked: true,
    },
    {
      value: "Initiated",
      viewValue: "Initiated",
      name: "Initiated",
      checked: true,
    },
    {
      value: "Submitted to Finance",
      viewValue: "Submitted to Finance",
      name: "Submitted to Finance",
      checked: false,
    },
    {
      value: "In Process",
      viewValue: "In Process",
      name: "In Process",
      checked: false,
    },
    {
      value: "Completed",
      viewValue: "Completed",
      name: "Completed",
      checked: false,
    },
    {
      value: "Rejected (HR)",
      viewValue: "Rejected (HR)",
      name: "Rejected (HR)",
      checked: false,
    },
    {
      value: "Rejected (Manager)",
      viewValue: "Rejected (Manager)",
      name: "Rejected (Manager)",
      checked: false,
    },
    {
      value: "Revoked (Employee)",
      viewValue: "Revoked (Employee)",
      name: "Revoked (Employee)",
      checked: false,
    },
    {
      value: "Revoked (HR)",
      viewValue: "Revoked (HR)",
      name: "Revoked (HR)",
      checked: false,
    },
    {
      value: "Revoked (Manager)",
      viewValue: "Revoked (Manager)",
      name: "Revoked (Manager)",
      checked: false,
    },
  ];

  DatesList: any[] = [
    {
      value: "Resignation Date",
      viewValue: "Resignation Date",
      name: "Resignation Date",
      checked: true,
    },
    {
      value: "Confirmed LWD",
      viewValue: "Confirmed LWD",
      name: "Confirmed LWD",
      checked: true,
    },
  ];

  monthsMapping: { [key: string]: string } = {
    "1": "Jan",
    "2": "Feb",
    "3": "Mar",
    "4": "Apr",
    "5": "May",
    "6": "Jun",
    "7": "Jul",
    "8": "Aug",
    "9": "Sep",
    "10": "Oct",
    "11": "Nov",
    "12": "Dec",
  };

  monthsList: any[] = [
    // { value: "", viewValue: "All" },
    ...Object.keys(this.monthsMapping).map((key) => ({
      value: key,
      viewValue: this.monthsMapping[key],
      name: this.monthsMapping[key],
      checked: true,
    })),
  ];

  selectedMonth: string[] = this.monthsList
    .map((month) => month.value)
    .filter((value) => value !== "");
  originalData: Offboarding[];
  ResponseList: any;
  isLWD: boolean = false;
  isThumbVisible: boolean = false;
  isThumbDisabled: boolean = false;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private _userService: UserService,
    private empsvc: EmployeeService // private changeDetection: ChangeDetectorRef
  ) {
    this.getExitReasons();
    this.offboarding = [];
    this.dataSourceFTE = new MatTableDataSource();
    this.dataSourceHR = new MatTableDataSource();
    this.dataSourceQueue = new MatTableDataSource();
    this.dataSource = new MatTableDataSource();
    this.dataSourceFinance = new MatTableDataSource();
    this.dataSourceComplete = new MatTableDataSource();
    this.allDepartments();
    this.dataSourceQueue.data = [];
    this.dataSourceHR.data = [];
    this.dataSourceFinance.data = [];
    this.dataSource.data = [];
    this.dataSourceComplete.data = [];
  }

  displayedColumns: string[] = [
    "EmpCode",
    "Name",
    "Location",
    "LastWorkingDay",
    "Finance",
    "Status",
  ];
  @ViewChild("paginator", { static: false }) paginator: MatPaginator;
  @ViewChild("sortFTE", { static: false }) sortFTE: MatSort;

  displayedColumnsQueue: string[] = [
    "EmpCode",
    "Name",
    "Location",
    "ResignationDate",
    "ResignationType",
    "IndicativeLWD",
    "ConfirmedLWD",
    "Manager",
    "Status",
    "Edit",
  ];

  exitcategorylist: any;
  @ViewChild("paginatorQueue", { static: false }) paginatorQueue: MatPaginator;
  @ViewChild("sortQueue", { static: false }) sortQueue: MatSort;
  @ViewChild("paginatorAll", { static: false }) paginatorAll: MatPaginator;
  @ViewChild("resgntype", { static: false }) resgntype: MatSelect;
  @ViewChild("select", { static: false }) select: MatSelect;
  @ViewChild("date", { static: false }) date: MatSelect;
  @ViewChild("month", { static: false }) month: MatSelect;

  displayedColumnsHR: string[] = [
    "EmpCode",
    "Name",
    "Location",
    "LastWorkingDay",
    "ManagerFeedback",
    "ITSupportFeedback",
    "AdminFeedback",
    "HRFeedback",
    "Status",
    "Edit",
  ];
  @ViewChild("paginatorHR", { static: false }) paginatorHR: MatPaginator;
  @ViewChild("sortHR", { static: false }) sortHR: MatSort;

  displayedColumnsFinance: string[] = [
    "EmpCode",
    "Name",
    "Location",
    "LastWorkingDay",
    "HRFeedback",
    "HRClearanceDate",
    "Finance",
    "Status",
  ];
  @ViewChild("paginatorFinance", { static: false })
  paginatorFinance: MatPaginator;
  @ViewChild("sortFinance", { static: false }) sortFinance: MatSort;

  displayedColumnsCompleted: string[] = [
    "EmpCode",
    "Name",
    "Location",
    "LastWorkingDay",
    "Clearance",
    "Status",
  ];
  @ViewChild("paginatorCom", { static: false }) paginatorCom: MatPaginator;
  @ViewChild("sortCom", { static: false }) sortCom: MatSort;

  @ViewChild("input", { static: false }) input: ElementRef;
  check: boolean = false;
  allDepartmentList: any = [];

  ngOnInit() {
    if (localStorage.getItem("statusListStorage")) {
      this.statusList = JSON.parse(localStorage.getItem("statusListStorage"));
    }
    if (localStorage.getItem("exitcategorylistStorage")) {
      this.exitcategorylist = JSON.parse(
        localStorage.getItem("exitcategorylistStorage")
      );
    }
    if (localStorage.getItem("finYearStorage")) {
      this.finYear = localStorage.getItem("finYearStorage");
    }
    if (localStorage.getItem("monthsListStorage")) {
      this.monthsList = JSON.parse(localStorage.getItem("monthsListStorage"));
    }
    if (localStorage.getItem("DatesListStorage")) {
      this.DatesList = JSON.parse(localStorage.getItem("DatesListStorage"));
    }
    if (localStorage.getItem("searchStorage")) {
      this.search =
        localStorage.getItem("searchStorage") === "null"
          ? ""
          : localStorage.getItem("searchStorage");
    }

    if (localStorage.getItem("resgntypeResultStorage") != "undefined") {
      this.resgntypeResult = JSON.parse(
        localStorage.getItem("resgntypeResultStorage")
      );
    }

    setTimeout(() => {
      localStorage.removeItem("statusListStorage");
      localStorage.removeItem("exitcategorylistStorage");
      localStorage.removeItem("finYearStorage");
      localStorage.removeItem("monthsListStorage");
      localStorage.removeItem("DatesListStorage");
      localStorage.removeItem("searchStorage");
      localStorage.removeItem("resgntypeResultStorage");
    }, 2000);
    this.route.params.subscribe((params) => {
      this.index = params["subIndex"];
      this.TabIndex = params["index"];
      this.offboardingId = params["id"];
    });
    this.permission = this._userService.userInfo.permissions.find(
      (i) => i.Name === "Offboarding-list"
    );
    this.loader = true;
    this.empCode = this._userService.getEmpCode();
    this.firstName = this._userService.getFullName();
    this.department = this._userService.getDepartment();
    //this.department = 'Delivery';
    this.email = this._userService.getEmail();
    this.HRfbRes = "HR";
    this.financeRes = "Finance";

    this.getHrQueueDetails()
      .then(() => this.getExitReasons())
      .then(() => {
        this.initializeSelections();
      })
      .catch((err) => console.error("Error fetching data", err));

    this.loadFinancialYears();
    this.getAllContacts();
    this.getOffboardingInwardDetailsFun();
    this.getIsPM();
    this.getPM();
    //this.getExitInterviewResponses();

    if (!localStorage.getItem("monthsListStorage")) {
      this.generateMonthsForFinancialYear(this.finYear);
    }

    if (sessionStorage.getItem("tabName") === "Finance Clearance") {
      if (
        this.permission.DeletingPermission &&
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingFinanceListAddPermissionFun();
      } else if (
        this.permission.HasFullAccess ||
        this.permission.DeletingPermission ||
        this.permission.EditingPermission ||
        this.permission.ReadOnlyPermission
      ) {
        this.getFinanceOffboardingList();
        //   this.getFinalOffboardingList();
      } else if (
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.DeletingPermission &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingFinanceListAddPermissionFun();
      } else {
        this.getFinanceOffboardingList();
      }
    } else if (sessionStorage.getItem("tabName") === "Completed Log") {
      if (
        this.permission.DeletingPermission &&
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingCompletedDeptListAddPermissionFun();
      } else if (
        this.permission.HasFullAccess ||
        this.permission.DeletingPermission ||
        this.permission.EditingPermission ||
        this.permission.ReadOnlyPermission
      ) {
        this.getFinalOffboardingList();
      } else if (
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.DeletingPermission &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingCompletedDeptListAddPermissionFun();
      } else {
        this.getFinalOffboardingList();
      }
    }

    if (sessionStorage.getItem("tabName") === "In Clearance") {
      if (
        this.permission.HasFullAccess ||
        this.permission.DeletingPermission ||
        this.permission.EditingPermission ||
        this.permission.ReadOnlyPermission ||
        this.isPM
      ) {
        this.getHROffboardingList();
      } else if (
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.DeletingPermission &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingHRListAddPermissionFun();
      } else {
        this.getHROffboardingList();
      }
    }
    // this.getHROffboardingList();
    //this.getOffboardingdetails();
    this.getOffboardingdetailsbyCode();
    this.getOffboardingQueueDetailsFun(true);

    if (sessionStorage.getItem("tabName") === "Listing") {
      if (
        this.permission.HasFullAccess ||
        this.permission.DeletingPermission ||
        this.permission.EditingPermission ||
        this.permission.ReadOnlyPermission
      ) {
        // this.getAllOffboardingQueueDetailsFunForHR();
      } else if (
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.DeletingPermission &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getAddPermissionOffBoardingListFun();
      } else {
        this.getAllOffboardingQueueDetailsFunForHR();
      }
    }

    this.getExitReasons();
    this.allDepartments();
    this.dataSourceQueue.paginator = this.paginator;
    this.dataSourceQueue.sort = this.sortQueue;

    if (this.offboardingId != null) {
      this.getEmployeeName(this.empCode).then(() => {
        this.getOffboardingDetailsById();
      });
    }

    if (this.permission.HasFullAccess || this.permission.EditingPermission)
      this.editEnable = true;
    if (this.permission.HasFullAccess || this.permission.DeletingPermission) {
      this.deleteEnable = true;
    }

    if (localStorage.getItem("tabIndex") != null) {
      this.TabIndex =
        this.TabIndex || Number(localStorage.getItem("tabIndex")) - 1;
      localStorage.removeItem("tabIndex");
    }
    setTimeout(() => {
      this.loader = false;
    }, 1500);
  }

  onPageChange(event: any) {
    this.dataSourceQueue.paginator.pageIndex = event.pageIndex;
    this.dataSourceQueue.paginator.pageSize = event.pageSize;
  }

  getAddPermissionOffBoardingListFun() {
    this.empsvc.getAddPermissionOffBoardingList(this.empCode).subscribe(
      (data: any) => {
        let arr = [];
        data &&
          data.map((item) => {
            if (item.Status === "Rejected") {
              if (item.Designation === "Manager") {
                item.Status = "Rejected (Manager)";
              } else if (item.Designation === "HR") {
                item.Status = "Rejected (HR)";
              }
            }

            if (item.Status === "Revoked") {
              if (item.HRResignationComments) {
                item.Status = "Revoked (HR)";
              } else if (item.ManagerResignationComments) {
                item.Status = "Revoked (Manager)";
              } else {
                item.Status = "Revoked (Employee)";
              }
            }

            const resignationDate = item.ResignationDate
              ? new Date(item.ResignationDate)
              : null;
            const monthNumber = resignationDate
              ? (resignationDate.getMonth() + 1).toString()
              : null;
            arr.push({
              ...item,
              ResignationDate:
                item.ResignationDate &&
                new Date(item.ResignationDate).toISOString().split("T")[0],
              MonthName: monthNumber ? this.monthsMapping[monthNumber] : null,
            });
          });

        let filteredData = arr.filter(({ Status, FromEmp, finalStatus }) => {
          return (
            (Status == "Saved" && FromEmp && finalStatus == "Confirmed") ||
            !(Status == "Saved" && FromEmp)
          );
        });

        if (
          this.permission.DeletingPermission &&
          !this.permission.HasFullAccess &&
          !this.permission.AddingPermission &&
          !this.permission.EditingPermission &&
          !this.permission.ReadOnlyPermission &&
          sessionStorage.getItem("tabName") === "Listing"
        ) {
          filteredData =
            filteredData &&
            filteredData.filter(
              ({ FromEmp, Status }) =>
                !(FromEmp || (Status !== "Saved" && Status !== "Initiated"))
            );
        }

        filteredData = filteredData.filter(
          ({ Status, FromEmp, finalStatus }) => {
            return (
              (Status == "Saved" && FromEmp && finalStatus == "Confirmed") ||
              !(Status == "Saved" && FromEmp) ||
              !(Status == "Saved" && finalStatus == "Saved" && FromEmp)
            );
          }
        );

        if (this.finYear && this.finYear !== "All") {
          filteredData = filteredData.filter(
            (x) => x.FinancialYear === this.finYear
          );
          const resignationYear = (emp) =>
            emp.ResignationDate
              ? new Date(emp.ResignationDate).getFullYear()
              : null;
          const lwdYear = (emp) =>
            emp.LastWorkingDay
              ? new Date(emp.LastWorkingDay).getFullYear()
              : null;

          filteredData = filteredData.filter(
            (emp) =>
              resignationYear(emp) === parseInt(this.finYear) ||
              lwdYear(emp) === parseInt(this.finYear)
          );
        }

        if (this.resgntypeResult && this.resgntypeResult.length < 2) {
          filteredData = filteredData.filter(
            (emp) =>
              emp.ExitID != null && this.resgntypeResult.includes(emp.ExitID)
          );
        }

        filteredData = filteredData.map((emp) => {
          if (emp.Status === "Rejected") {
            emp.Status =
              emp.Designation === "Manager"
                ? "Rejected (Manager)"
                : "Rejected (HR)";
          } else if (emp.Status === "Revoked") {
            emp.Status = emp.HRResignationComments
              ? "Revoked (HR)"
              : emp.ManagerResignationComments
              ? "Revoked (Manager)"
              : "Revoked (Employee)";
          }
          return emp;
        });

        if (
          (this.statusList && this.statusList.length) !==
            (this.statusResult && this.statusResult.length) &&
          this.statusResult &&
          this.statusResult.length > 0
        ) {
          filteredData = filteredData.filter(
            (emp) => emp.Status && this.statusResult.includes(emp.Status)
          );
        }

        if (this.DateResult && this.selectedMonth.length < 2) {
          filteredData = filteredData.filter((emp) => {
            const resignationDateMonth = emp.ResignationDate
              ? new Date(emp.ResignationDate).getMonth() + 1
              : null;
            const lwdMonth = emp.LastWorkingDay
              ? new Date(emp.LastWorkingDay).getMonth() + 1
              : null;

            return (
              (this.DateResult.includes("Resignation Date") &&
                resignationDateMonth !== null &&
                this.selectedMonth.includes(resignationDateMonth.toString())) ||
              (this.DateResult.includes("Confirmed LWD") &&
                lwdMonth !== null &&
                this.selectedMonth.includes(lwdMonth.toString()))
            );
          });
        }

        if (this.search) {
          filteredData = filteredData.filter(
            (res) =>
              (res.Name &&
                res.Name.toLowerCase().includes(
                  this.removeExtraSpaces(this.search.toLowerCase())
                )) ||
              res.EmpCode.toString().includes(this.search.toLowerCase())
          );
        }

        if (
          (!this.resgntypeResult || this.resgntypeResult.length === 0) &&
          (!this.statusResult || this.statusResult.length === 0) &&
          !this.search
        ) {
          filteredData = [];
        }

        this.dataSourceQueue.data = filteredData;
        this.updateCount();

        return filteredData;

        // this.dataSourceQueue.data = [...filteredData];
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getOffboardingHRListAddPermissionFun() {
    this.empsvc.getOffboardingHRListAddPermission(this.empCode).subscribe(
      (data: any) => {
        let finalInClearanceRes = [];
        let managerIconArr = data || [];

        if (
          this.permission.DeletingPermission &&
          sessionStorage.getItem("tabName") === "In Clearance"
        ) {
          finalInClearanceRes =
            data &&
            data.filter(
              ({ FromEmp, Status }) => !(Status == "In Process")
              // FromEmp ||
            );
        }

        if (
          this.permission.AddingPermission &&
          sessionStorage.getItem("tabName") === "In Clearance"
        ) {
          const addRecords =
            data &&
            data.filter(({ CreatedBy }) => {
              return Number(CreatedBy) === this.empCode;
            });
          finalInClearanceRes = [...addRecords, ...finalInClearanceRes];
        }

        if (
          this.permission.HasFullAccess ||
          this.permission.EditingPermission ||
          this.permission.ReadOnlyPermission
        ) {
          finalInClearanceRes = data;
        }

        finalInClearanceRes =
          finalInClearanceRes &&
          finalInClearanceRes.filter(({ Status }) => Status !== "Saved");

        this.offboardingHR = finalInClearanceRes;

        this.dataSourceHR.data = this.offboardingHR;
        this.dataSourceHR.paginator = this.paginatorHR;

        if (
          this.department == this.HRfbRes ||
          this.department == this.financeRes
        ) {
          this.dataSourceFinance.data = this.offboardingFinance;
          this.dataSource.data = this.offboardingFinal;
          for (var i = 0; i < this.offboardingFinal.length; i++) {
            this.offboardingFinal[i].HrIcon = true;
          }
          for (var i = 0; i < this.offboardingFinance.length; i++) {
            this.offboardingFinance[i].HrIcon = true;
          }
        } else {
          this.dataSource.data = [];
          this.dataSourceFinance.data = [];
        }

        this.pmcodeList = finalInClearanceRes;

        //List of employees resigned under People managers whose depts not as below
        if (
          this.pmcodeList.length != 0 &&
          this.department != "HR" &&
          this.department != "Finance" &&
          this.department != "Admin" &&
          this.department != "IT"
        ) {
          // this.codeExistsinPMList = true;
          this.deptWithPM = this.pmcodeList.filter((x) => x.Status != "Saved");
          this.pmcodeList = this.deptWithPM;
          this.dataSourceHR.data = this.pmcodeList;
          this.offboardingHR = this.dataSourceHR.data;
          this.dataSource.data = [];
          this.dataSourceFinance.data = [];
        }

        //Full List for dept=hr(not managers) and people in offboarding settings
        else if (
          this.pmcodeList.length == 0 &&
          (this.mailexitsIT == true || this.mailexitsAdmin == true)
        ) {
          this.codeExistsinPMList = false;
          this.deptWithoutPM = this.offboardingHR.filter(
            (x) => x.Status != "Saved"
          );
          this.offboardingHR = this.deptWithoutPM;
          this.dataSourceHR.data = this.offboardingHR;
          this.offboardingHR = this.dataSourceHR.data;
        }

        //List for being HR   --  this.department == this.HRfbRes //newextra
        else if (
          this.permission.HasFullAccess ||
          this.permission.EditingPermission ||
          this.permission.ReadOnlyPermission ||
          this.permission.DeletingPermission
        ) {
          this.dataSourceHR.data = this.offboardingHR;
          this.offboardingHR = this.dataSourceHR.data;
          this.codeExistsinPMList = false;
        } else if (
          this.pmcodeList.length != 0 &&
          (this.department == "Admin" || this.department == "IT")
        ) {
          this.ITAdminWithPM = this.offboardingHR.filter(
            (x) => x.Status != "Saved"
          );
          this.offboardingHR = this.ITAdminWithPM;
          this.dataSourceHR.data = this.offboardingHR;
        }

        //List for being finance manager
        else if (this.pmcodeList.length != 0 && this.department == "Finance") {
          this.FinanceWithPM = this.pmcodeList.filter(
            (x) => x.Status != "Saved"
          );
          this.pmcodeList = this.FinanceWithPM;
          this.offboardingHR = this.pmcodeList;
          this.dataSourceHR.data = this.offboardingHR;
        }

        //First list empty
        else {
          if (this.pmcodeList.length != 0) {
            this.deptWithPM = this.pmcodeList.filter(
              (x) => x.Status != "Saved"
            );
            this.dataSourceHR.data = this.pmcodeList;
          } else {
            this.dataSourceHR.data = [];
            this.offboardingHR = this.dataSourceHR.data;
            this.codeExistsinPMList = false;
          }
        }

        var filterFinanceYearListHR = this.dataSourceHR.data.filter(
          (x) => x.FinancialYear == this.finYear
        );
        this.dataSourceHR.data = filterFinanceYearListHR;
        var filterFinanceYearListFinance = this.dataSourceFinance.data.filter(
          (x) => x.FinancialYear == this.finYear
        );
        this.dataSourceFinance.data = filterFinanceYearListFinance;
        var filterFinanceYearListFinal = this.dataSource.data.filter(
          (x) => x.FinancialYear == this.finYear
        );
        this.dataSource.data = filterFinanceYearListFinal;

        if (this.dataSourceHR.data.length == 0) {
          this.showEmptyMessageHR = "No Records Found";
          this.emptyRecordbooleanHR = true;
        } else {
          this.emptyRecordbooleanHR = false;

          this.showEmptyMessageHR = "";
        }
        if (this.dataSourceFinance.data.length == 0) {
          this.showEmptyMessageFinance = "No Records Found";
          this.emptyRecordbooleanFinance = true;
        } else {
          this.emptyRecordbooleanFinance = false;

          this.showEmptyMessageFinance = "";
        }
        if (this.dataSource.data.length == 0) {
          this.showEmptyMessage = "No Records Found";
          this.emptyRecordboolean = true;
        } else {
          this.emptyRecordboolean = false;

          this.showEmptyMessage = "";
        }

        for (var i = 0; i < this.offboardingHR.length; i++) {
          if (managerIconArr.length != 0) {
            for (var j = 0; j < managerIconArr.length; j++) {
              if (managerIconArr[j].EmpCode === this.offboardingHR[i].EmpCode) {
                this.offboardingHR[i].mgrIconDept = true;
              }
            }
          }
        }

        for (var i = 0; i < this.offboardingHR.length; i++) {
          if (this.offboardingHR[i].HRFinalFeedback == true) {
            this.offboardingHR[i].disableIcon = true;
          } else this.offboardingHR[i].disableIcon = false;

          if (this.codeExistsinPMList == true) {
            this.offboardingHR[i].ManagerIcon = true;
            this.offboardingHR[i].ItIcon = false;
            this.offboardingHR[i].AdminIcon = false;
            this.offboardingHR[i].HrIcon = false;
          } else this.offboardingHR[i].ManagerIcon = false;
          if (
            this.mailexitsIT == true &&
            this.offboardingHR[i].ManagerFeedBack == true
          ) {
            // && this.codeExistsinPMList == false) {
            this.offboardingHR[i].ItIcon = true;
            this.offboardingHR[i].AdminIcon = false;
            this.offboardingHR[i].ManagerIcon = false;
            this.offboardingHR[i].HrIcon = false;
          } else this.offboardingHR[i].ItIcon = false;

          if (
            this.mailexitsAdmin == true &&
            this.offboardingHR[i].ManagerFeedBack == true
          ) {
            // && this.codeExistsinPMList == false) {
            this.offboardingHR[i].AdminIcon = true;
            this.offboardingHR[i].ManagerIcon = false;
            this.offboardingHR[i].ItIcon = false;
            this.offboardingHR[i].HrIcon = false;
          } else this.offboardingHR[i].AdminIcon = false;
          if (
            this.department == this.HRfbRes &&
            this.offboardingHR[i].ManagerFeedBack == true
          ) {
            this.offboardingHR[i].HrIcon = true;
            this.offboardingHR[i].AdminIcon = false;
            this.offboardingHR[i].ManagerIcon = false;
            this.offboardingHR[i].ItIcon = false;
          } else this.offboardingHR[i].HrIcon = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getOffboardingFinanceListAddPermissionFun() {
    this.empsvc.getOffboardingFinanceListAddPermission(this.empCode).subscribe(
      (data: any) => {
        const addRecords =
          data &&
          data.filter(({ CreatedBy }) => {
            return Number(CreatedBy) === this.empCode;
          });

        this.offboardingFinance = addRecords || [];

        this.dataSourceFinance.data = this.offboardingFinance;

        this.dataSourceFinance.paginator = this.paginatorFinance;

        this.getEmpListByPMCode();
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getOffboardingCompletedDeptListAddPermissionFun() {
    this.empsvc
      .getOffboardingCompletedDeptListAddPermission(this.empCode)
      .subscribe(
        (data: any) => {
          let filterFinanceYearList = data.filter((x) => {
            const lastWorkingDate = new Date(x.LastWorkingDay);
            const lastWorkingYear = lastWorkingDate.getFullYear();
            const startYear = this.finYear.split("-")[0];
            return lastWorkingYear.toString() === startYear;
          });

          this.offboardingFinal = filterFinanceYearList;

          this.dataSource.data = filterFinanceYearList;

          this.dataSource.paginator = this.paginator;

          this.getEmpListByPMCode();
        },
        (error) => {
          this.error = error;
        }
      );
  }

  allDepartments() {
    this.empsvc.getDepartmentsApi().subscribe(
      (data: any) => {
        this.allDepartmentList =
          data && data.map(({ DepartmentName }) => DepartmentName);
      },
      (error) => {
        this.error = error;
      }
    );
  }

  filterBtnClick(val) {
    if (this.resgntypeResult && this.resgntypeResult.length === 0) {
      const preparedFinalList = this.prepareResponseUnselect(
        this.exitcategorylist,
        "ExitReasonCategory"
      );
      if (!localStorage.getItem("exitcategorylistStorage")) {
        this.exitcategorylist = preparedFinalList || [];
      }
    } else {
      const preparedFinalList = this.prepareResponseCustom(
        this.exitcategorylist,
        "ExitReasonCategory",
        this.resgntypeResult
      );
      if (!localStorage.getItem("exitcategorylistStorage")) {
        this.exitcategorylist = preparedFinalList || [];
      }
    }

    if (this.statusResult && this.statusResult.length === 0) {
      const preparedFinalList = this.statusList.map((item) => ({
        ...item,
        checked: false,
      }));
      this.statusList = preparedFinalList || [];
    } else {
      this.statusResult = this.statusResult || [];
      this.statusList = this.statusList.map((item) =>
        this.statusResult.includes(item.value)
          ? {
              ...item,
              checked: true,
            }
          : item
      );
    }
    if (this.DateResult && this.DateResult.length === 0) {
      const preparedFinalList = this.DatesList.map((item) => ({
        ...item,
        checked: false,
      }));
      this.DatesList = preparedFinalList || [];
    } else {
      this.DateResult = this.DateResult || [];
      this.DatesList = this.DatesList.map((item) =>
        this.DateResult.includes(item.value)
          ? {
              ...item,
              checked: true,
            }
          : item
      );
    }

    if (this.selectedMonth && this.selectedMonth.length === 0) {
      const preparedFinalList = this.monthsList.map((item) => ({
        ...item,
        checked: false,
      }));
      this.monthsList = preparedFinalList || [];
    } else {
      this.selectedMonth = this.selectedMonth || [];
      this.monthsList = this.monthsList.map((item) =>
        this.selectedMonth.includes(item.value)
          ? {
              ...item,
              checked: true,
            }
          : {
              ...item,

              checked: false,
            }
      );
    }
  }

  initializeSelections() {
    if (!localStorage.getItem("exitcategorylistStorage")) {
      this.resgntypeResult = this.exitcategorylist.map(
        (status) => status.ExitID
      );
    }
    this.selectedAllTypes = true;
    this.statusResult = this.statusList
      .filter((status) => status.checked === true)
      .map((status) => status.value);

    this.selectedAllStatus = true;
    this.DateResult = this.DatesList.map((status) => status.value);
    this.selectedAllDates = true;
    this.selectedMonth = this.monthsList.map((month) => month.value);
    this.filterRecords();
  }

  prepareResponse(dataList, key) {
    const finalRes: any = [];
    dataList.forEach((item: any) => {
      item = { ...item, name: item[key], checked: true };
      finalRes.push(item);
    });
    return finalRes;
  }

  prepareResponseUnselect(dataList, key) {
    const finalRes: any = [];
    dataList.forEach((item: any) => {
      item = { ...item, name: item[key], checked: false };
      finalRes.push(item);
    });
    return finalRes;
  }

  prepareResponseCustom(dataList, key, selectedList) {
    const finalRes: any = [];
    dataList.forEach((item: any) => {
      item = {
        ...item,
        name: item[key],
        checked: selectedList.includes(item.ID || item.ExitID) ? true : false,
      };
      finalRes.push(item);
    });
    return finalRes;
  }

  shareCheckedList(item: any[], type) {
    if (type === "Status") {
      this.statusResult = item;

      this.statusList.forEach((status) => {
        status.checked = item.includes(status.value);
      });
      this.filterRecords();
    }
    if (type === "Datesfilter") {
      this.DateResult = item;
    }
  }

  shareIndividualCheckedList(item: {}) {
    this.filterRecords();
  }

  shareCheckedListFullObj(item: any[], type) {
    if (type === "ResignationType") {
      this.resgntypeResult = item.map(({ ExitID }) => ExitID);
    }
    if (type === "selectedMonth") {
      this.selectedMonth = item.map(({ value }) => value);
      this.filterRecords();
    }

    if (type === "selectedMonths") {
      this.selectedMonths = item.map(({ value }) => value);
      this.onMonthSelectionChange();
    }
    // console.log("===this.selectedMonths===", this.selectedMonths);
  }

  //applyFilter(filterValue: string) {
  //  this.dataSource.filter = filterValue.trim().toLowerCase();
  //}

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onMonthSelectionChange() {
    this.applyMonthFilter();
  }

  applyMonthFilter() {
    if (this.selectedMonths.length === 0) {
      this.dataSource.data = []; //[...this.originalData];
      return;
    }
    const filteredData = this.originalData.filter((element) => {
      const lastWorkingDate = new Date(element.LastWorkingDay); // Assuming LastWorkingDay is in 'yyyy-MM-dd' format
      const month = lastWorkingDate.getMonth() + 1; // getMonth() returns 0-11, so add 1 to get the actual month number

      // Format month to match with the selected month's format (e.g., "Apr-24")
      const selectedMonthFormatted = `${
        this.monthsMapping[month]
      }-${this.finYear.split("-")[0].slice(-2)}`;

      return this.selectedMonths.includes(month.toString()); // Check if the formatted month is selected
    });

    // Update dataSource after filtering
    this.dataSource.data = filteredData;
  }

  applyFilterHR(filterValue: string) {
    if (sessionStorage.getItem("tabName") === "In Clearance") {
      if (this.dataSourceHR_bkp && this.dataSourceHR_bkp.length === 0) {
        this.dataSourceHR_bkp = this.dataSourceHR.data;
      }
      if (this.inClearanceSearch || filterValue) {
        const filterFinalRes =
          this.dataSourceHR_bkp &&
          this.dataSourceHR_bkp.filter(({ Name, EmpCode }) => {
            return (
              (Name &&
                Name.toLowerCase().startsWith(filterValue.toLowerCase())) ||
              (EmpCode &&
                EmpCode.toString().startsWith(filterValue.toLowerCase()))
            );
          });
        this.dataSourceHR.data = filterFinalRes;
      } else {
        this.dataSourceHR.data = this.dataSourceHR_bkp;
      }
    } else {
      this.dataSourceHR.filter = filterValue.trim().toLowerCase();
    }
  }
  applyFilterComplete(filterValue: string) {
    this.dataSourceComplete.filter = filterValue.trim().toLowerCase();
  }
  applyFilterFinance(filterValue: string) {
    this.dataSourceFinance.filter = filterValue.trim().toLowerCase();
  }

  rowClick(Id) {
    localStorage.setItem("statusListStorage", JSON.stringify(this.statusList));
    localStorage.setItem(
      "exitcategorylistStorage",
      JSON.stringify(this.exitcategorylist)
    );
    localStorage.setItem("finYearStorage", this.finYear);
    localStorage.setItem("monthsListStorage", JSON.stringify(this.monthsList));
    localStorage.setItem("DatesListStorage", JSON.stringify(this.DatesList));
    localStorage.setItem("searchStorage", this.search || null);
    localStorage.setItem(
      "resgntypeResultStorage",
      JSON.stringify(this.resgntypeResult)
    );
    this.router.navigateByUrl("/offboardingdetails/" + Id);
  }

  getIsPM() {
    this.empsvc.getEmpListByPMCode(this.empCode).subscribe(
      (data: Offboarding[]) => {
        this.isPMList = data;
        let filteredData = data || [];
        // filteredData =
        //   data && data.filter(({ Status }) => Status === "Initiated");
        if (filteredData.length > 0) {
          this.isPMtrue = true;
        } else {
          this.isPMtrue = false;
        }

        if (this.isPMtrue == false && this.department == "Finance") {
          this.firstTabHide = true;
        } else {
          this.firstTabHide = false;
        }

        this.isPMHR =
          this.isPM && this.allDepartmentList.includes(this.department)
            ? true
            : false;
        this.onlyHR =
          this.isPM && this.department === "HR"
            ? false
            : this.department === "HR"
            ? true
            : false;
        this.isInWardTrue =
          this.offboardingEmpListInWard &&
          this.offboardingEmpListInWard.length > 0
            ? true
            : false;
        // if (sessionStorage.getItem("tabName") === "In Clearance") {
        //   if (this.isPM) {
        //     this.getHROffboardingList();
        //   }
        // }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getPM() {
    this.empsvc.getPMByCode(this.empCode).subscribe(
      (data: any) => {
        this.isPM = data;
        this.isPMHR =
          this.isPM && this.allDepartmentList.includes(this.department)
            ? true
            : false;
        this.onlyHR =
          this.isPM && this.department === "HR"
            ? false
            : this.department === "HR"
            ? true
            : false;
        this.isInWardTrue =
          this.offboardingEmpListInWard &&
          this.offboardingEmpListInWard.length > 0
            ? true
            : false;
        if (this.index != null) {
          this.fromRouting = true;
          if (!this.isPMHR && this.isPM) {
            this.managerTabIdx = this.index;
          } else {
            this.TabIndex = this.TabIndex || 0;
            this.managerTabIdx = this.index;
          }
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getExitReasons() {
    this.empsvc.GetExitReasons().subscribe((data: any) => {
      const preparedFinalList = this.prepareResponse(
        data,
        "ExitReasonCategory"
      );
      if (!localStorage.getItem("exitcategorylistStorage")) {
        this.exitcategorylist = preparedFinalList || [];
      }
    });
  }

  getExitReason(exitID: number): string {
    if (!this.exitcategorylist) {
      return "--NA--";
    }
    const exitCategory = this.exitcategorylist.find(
      (item) => item.ExitID === exitID
    );
    return exitCategory ? exitCategory.ExitReasonCategory : "--NA--";
  }

  tabClickManager(event) {
    this.managerTabIdx = event.index;
    this.searchInputValue = "";
    this.loadFinancialYears();
    this.getOffboardingInwardDetailsFun();
    this.getOffboardingQueueDetailsFun(false);
    if (event.index == 0) {
      if (!this.isPMHR && this.isPM)
        this.router.navigateByUrl("Offboardinglist/tabIndex/0");
      this.totalCount =
        this.offboardingEmpListMyApproval &&
        this.offboardingEmpListMyApproval.length;
    } else if (event.index == 1) {
      this.totalCount =
        this.offboardingEmpListApproved &&
        this.offboardingEmpListApproved.length;
    } else if (event.index == 2) {
      this.totalCount =
        this.offboardingEmpListRejected &&
        this.offboardingEmpListRejected.length;
    } else if (event.index == 3) {
      this.totalCount =
        this.offboardingEmpListInWard && this.offboardingEmpListInWard.length;
    }
  }

  tabClick(event) {
    this.resetFilter();
    this.loader = true;
    this.TabIndex = event.index;
    this.tabName = event.tab.textLabel;
    sessionStorage.setItem("tabIndex", event.index.toString());
    sessionStorage.setItem("tabName", event.tab.textLabel);
    sessionStorage.setItem("mainHeaderSelectedTab", "Offboardinglist");
    sessionStorage.setItem("mainHeaderUrl", "/Offboardinglist/tabIndex/0");
    this.router.navigateByUrl("/Offboardinglist/tabIndex/" + event.index);

    this.searchInputValue = "";

    if (this.index != null && !this.fromRouting) {
      localStorage.setItem("tabIndex", event.index.toString());
      localStorage.getItem("tabIndex");
      // this.router.navigateByUrl("Offboardinglist");
    } else if (this.fromRouting) {
      this.fromRouting = false;
    }
    if (this.index == null && !this.fromRouting) this.managerTabIdx = 0;
    this.loadFinancialYears();
    this.getOffboardingInwardDetailsFun();
    this.getOffboardingQueueDetailsFun(false);
    if (sessionStorage.getItem("tabName") === "In Clearance") {
      if (
        this.permission.HasFullAccess ||
        this.permission.DeletingPermission ||
        this.permission.EditingPermission ||
        this.permission.ReadOnlyPermission ||
        this.isPM
      ) {
        this.getHROffboardingList();
      } else if (
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.DeletingPermission &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingHRListAddPermissionFun();
      } else {
        this.getHROffboardingList();
      }
    } else if (sessionStorage.getItem("tabName") === "Finance Clearance") {
      if (
        this.permission.DeletingPermission &&
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingFinanceListAddPermissionFun();
      } else if (
        this.permission.HasFullAccess ||
        this.permission.DeletingPermission ||
        this.permission.EditingPermission ||
        this.permission.ReadOnlyPermission
      ) {
        this.getFinanceOffboardingList();
      } else if (
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.DeletingPermission &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingFinanceListAddPermissionFun();
      } else {
        this.getFinanceOffboardingList();
      }
    } else if (sessionStorage.getItem("tabName") === "Completed Log") {
      if (
        this.permission.DeletingPermission &&
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingCompletedDeptListAddPermissionFun();
      } else if (
        this.permission.HasFullAccess ||
        this.permission.DeletingPermission ||
        this.permission.EditingPermission ||
        this.permission.ReadOnlyPermission
      ) {
        this.getFinalOffboardingList();
      } else if (
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.DeletingPermission &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingCompletedDeptListAddPermissionFun();
      } else {
        this.getFinalOffboardingList();
      }
    } else if (sessionStorage.getItem("tabName") === "Listing") {
      if (
        this.permission.HasFullAccess ||
        this.permission.DeletingPermission ||
        this.permission.EditingPermission ||
        this.permission.ReadOnlyPermission ||
        this.isPM
      ) {
        // this.getAllOffboardingQueueDetailsFunForHR();
        this.getHrQueueDetails();
      } else if (
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.DeletingPermission &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getAddPermissionOffBoardingListFun();
      } else {
        this.getAllOffboardingQueueDetailsFunForHR();
      }
    } else {
      this.getOffboardingCompletedDeptList();
    }
    this.generateMonthsForFinancialYear(this.finYear);
    setTimeout(() => {
      this.loader = false;
    }, 2000);
  }

  onMouseLeave(event: MouseEvent): void {
    if (
      ![
        "cdk-overlay-backdrop cdk-overlay-transparent-backdrop-cs",
        "cdk-overlay-backdrop cdk-overlay-transparent-backdrop",
        "mat-option-text",
        "mat-select-panel-wrap ng-tns-c4-56 ng-trigger ng-trigger-transformPanelWrap ng-star-inserted",
      ].includes((event.relatedTarget as HTMLInputElement).className)
    ) {
      this.isOpen = !this.isOpen;
    }
  }

  getOffboardingDetailsById() {
    this.getEmployeeName(this._userService.getEmpCode);
    this.empsvc
      .getOffboardingDetailsById(this.offboardingId)
      .subscribe((data: Offboarding) => {
        const finalData = data;
        if (finalData != null && finalData.EmpCode == this.empCode) {
          // this.router.navigateByUrl("myprofile/" + this.empCode);
          // window.location.href =
          //   "https://qa-winemployee.azurewebsites.net/" +
          //   "myprofile/" +
          //   this.empCode;
        } else {
          // window.location.href =
          //   "https://qa-winhr.azurewebsites.net/" +
          //   "Offboardinglist/tabIndex/0";
          // this.router.navigateByUrl("Offboardinglist/tabIndex/0");
          //var cc;
          //if (finalData.CC) {
          //  cc = finalData.CC.split(",");
          //}
          //if (this.name == finalData.To) {
          //  if (finalData.finalStatus == this.hrStatus.Submit) {
          //    if (!this.isPMHR && this.isPM) {
          //      this.managerTabIdx = 0;
          //    } else {
          //      this.TabIndex = this.TabIndex || 0;
          //      this.managerTabIdx = 0;
          //    }
          //  } else if (finalData.finalStatus == this.hrStatus.Reject) {
          //    if (!this.isPMHR && this.isPM) {
          //      this.managerTabIdx = 2;
          //    } else {
          //      this.TabIndex = this.TabIndex || 0;
          //      this.managerTabIdx = 2;
          //    }
          //  } else {
          //    if (!this.isPMHR && this.isPM) {
          //      this.managerTabIdx = 1;
          //    } else {
          //      this.TabIndex = this.TabIndex || 0;
          //      this.managerTabIdx = 1;
          //    }
          //  }
          //} else if (this.empCode == finalData.EmpCode) {
          //  this.router.navigateByUrl("myprofile/" + this.empCode);
          //} else if (cc != null && cc.includes(this.name)) {
          //  if (!this.isPMHR && this.isPM) {
          //    this.managerTabIdx = 3;
          //  } else {
          //    this.TabIndex = this.TabIndex || 0;
          //    this.managerTabIdx = 3;
          //  }
          //} else if (this.department == "HR") {
          //  this.TabIndex = this.TabIndex || 0;
          //} else {
          //  this.router.navigateByUrl("myprofile/" + this.empCode);
          //}
        }
      });
  }
  thumbClick(val) {
    const message = `Would you like to initiate exit interview?`;
    var deleteType = "Submit";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.loader = true;
          this.empsvc.sendEmployeeFeeedback(val).subscribe(
            (data) => {
              this.toastr.success(
                "Exit interview questions initiated successfully "
              );
              //this.loader = false;
              this.getAllOffboardingQueueDetailsFunForHR();
              this.getHROffboardingList();

              window.scrollTo(0, 0);
              setTimeout(() => {
                this.loader = false;
              }, 1000);
            },
            (error) => {
              this.error = error;
              this.loader = false;
            }
          );
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }

  deleteEmployee(val) {
    const message = `Are you sure to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.loader = true;
          this.empsvc.DeleteOffboardingEmployee(val).subscribe(
            (data) => {
              this.toastr.success("Deleted Successfully.");
              //this.loader = false;
              this.getAllOffboardingQueueDetailsFunForHR();
              this.getHROffboardingList();

              window.scrollTo(0, 0);
              setTimeout(() => {
                this.loader = false;
              }, 1000);
            },
            (error) => {
              this.error = error;
              this.loader = false;
            }
          );
        }
      },
      (error) => {
        this.loader = false;
        this.result = error;
      }
    );
  }
  GetFeedbackchecklist(value: any, code: any, element: any) {
    if (value == 1) {
      this.feedbackType = "Manager";
      localStorage.setItem("hrOffboardingID", element.ID);
      this.router.navigateByUrl(
        "/offboardingfeedback/" + this.feedbackType + "/" + code
      );
    } else if (value == 3) {
      this.feedbackType = "IT";
      this.router.navigateByUrl(
        "/offboardingfeedback/" + this.feedbackType + "/" + code
      );
      localStorage.setItem("hrOffboardingID", element.ID);
    } else if (value == 2) {
      this.feedbackType = "Admin";
      this.router.navigateByUrl(
        "/offboardingfeedback/" + this.feedbackType + "/" + code
      );
      localStorage.setItem("hrOffboardingID", element.ID);
    } else if (value == 4) {
      this.feedbackType = "HR";
      this.router.navigateByUrl(
        "/offboardingfeedback/" + this.feedbackType + "/" + code
      );
      localStorage.setItem("hrOffboardingID", element.ID);
    } else if (value == 5) {
      this.feedbackType = "Finance";
      this.router.navigateByUrl(
        "/offboardingfeedback/" + this.feedbackType + "/" + code
      );
      localStorage.setItem("hrOffboardingID", element.ID);
    }
    this.empsvc
      .getOffboardingFeedbackTypeDescription(this.feedbackType, code)
      .subscribe((data: any[]) => {
        this.checklist = data;
      });
  }
  getHROffboardingList() {
    this.empsvc.getOffboardingHRList().subscribe(
      (data: Offboarding[]) => {
        let finalInClearanceRes = [];

        if (
          this.permission.DeletingPermission &&
          sessionStorage.getItem("tabName") === "In Clearance"
        ) {
          finalInClearanceRes = data;
          // &&
          // data.filter(
          //   ({ FromEmp, Status }) => !(FromEmp || Status == "In Process")
          //   // FromEmp ||
          // );
        }

        if (
          this.permission.AddingPermission &&
          sessionStorage.getItem("tabName") === "In Clearance"
        ) {
          const addRecords =
            data &&
            data.filter(({ CreatedBy }) => {
              return Number(CreatedBy) === this.empCode;
            });
          finalInClearanceRes = [...addRecords, ...finalInClearanceRes];
        }

        if (
          this.permission.HasFullAccess ||
          this.permission.EditingPermission ||
          this.permission.ReadOnlyPermission
        ) {
          finalInClearanceRes = data;
        }

        // if (
        //   this.permission.DeletingPermission &&
        //   sessionStorage.getItem("tabName") === "In Clearance"
        // ) {
        // this.offboardingHR = finalInClearanceRes;
        this.inClearanceData = finalInClearanceRes;

        if (
          this.permission.HasFullAccess ||
          this.permission.EditingPermission ||
          this.permission.ReadOnlyPermission ||
          this.permission.DeletingPermission
        ) {
          this.dataSourceHR.data = this.inClearanceData;
          this.dataSourceHR.paginator = this.paginatorHR;
          this.getEmpListByPMCode();
        } else if (this.isPM) {
          this.getEmpListByPMCode();
        } else {
          this.dataSourceHR.data = this.offboardingHR;
          this.dataSourceHR.paginator = this.paginatorHR;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }
  getFinanceOffboardingList() {
    this.empsvc.getOffboardingFinanceList().subscribe(
      (data: Offboarding[]) => {
        this.offboardingFinance = data;

        this.dataSourceFinance.data = this.offboardingFinance;

        this.dataSourceFinance.paginator = this.paginatorFinance;

        this.getEmpListByPMCode();
      },
      (error) => {
        this.error = error;
      }
    );
  }

  //getFinalOffboardingList() {
  //  this.empsvc.getOffboardingClearanceList().subscribe(
  //    (data: Offboarding[]) => {
  //      this.offboardingFinal = data;
  //      this.originalData = data;
  //      this.dataSource.data = this.originalData;
  //      this.dataSource.paginator = this.paginator;
  //      this.getEmpListByPMCode();
  //    },
  //    (error) => {
  //      this.error = error;
  //    }
  //  );
  //}

  getFinalOffboardingList() {
    this.empsvc.getOffboardingClearanceList().subscribe(
      (data: Offboarding[]) => {
        this.offboardingFinal = data;
        let filterFinanceYearList = data.filter((x) => {
          const lastWorkingDate = new Date(x.LastWorkingDay);
          const lastWorkingYear = lastWorkingDate.getFullYear();
          const startYear = this.finYear.split("-")[0];
          return lastWorkingYear.toString() === startYear;
        });
        filterFinanceYearList = filterFinanceYearList.map((item) => {
          item.FinancialYear = this.finYear;
          return item;
        });

        this.dataSource.data = filterFinanceYearList;
        this.offboardingFinal = filterFinanceYearList;
        this.originalData = filterFinanceYearList;
        //this.dataSource.data = this.originalData;
        this.dataSource.paginator = this.paginator;
        this.getEmpListByPMCode();
      },
      (error) => {
        this.error = error;
      }
    );
  }

  loadFinancialYears() {
    this.FinancialYears = [];
    var now = new Date();
    var mm = now.getMonth() + 1;
    var currentYear;
    var year;
    currentYear = now.getFullYear();
    year = now.getFullYear().toString().substr(2, 2);

    for (var i = 2021; i <= currentYear; i++) {
      this.FinancialYears.push({
        FinancialYearId: i.toString().substr(2, 2),
        FinancialYear: i + "-" + (i + 1).toString().substr(2, 2),
      });
    }
    if (3 < mm) {
      currentYear = now.getFullYear();
      year = now.getFullYear().toString().substr(2, 2);
    } else {
      currentYear = now.getFullYear() - 1;
      year = (now.getFullYear() - 1).toString().substr(2, 2);
    }
    this.finYear = currentYear + "-" + (parseInt(year) + 1);
  }

  onPremiumYearChange(val) {
    this.finYear = val.value;
    this.generateMonthsForFinancialYear(this.finYear);
    // this.getEmpListForLastTab();
    // this.getEmpListByPMCode();
    // this.getFinalOffboardingList();
    // this.getOffboardingCompletedDeptListAddPermissionFun();
    const selectedMonthsOld = this.monthsList.map(({ name }) => name);

    let data =
      this.originalDataSourceAll != null &&
      this.originalDataSourceAll.length > 0
        ? this.originalDataSourceAll
        : [];
    let filteredDataOld = [...data];
    // this.originalData, filteredDataOld
    let finalarr = [];
    // filteredDataOld.map((element) => {
    //   const lastWorkingDate = new Date(element.LastWorkingDay);
    //   const month = lastWorkingDate.getMonth() + 1;
    //   const year = lastWorkingDate.getFullYear().toString();

    //   const selectedMonthFormatted = `${
    //     this.monthsMapping[month]
    //   }-${year.split("-")[0].slice(-2)}`;

    //   if(selectedMonthsOld.includes(selectedMonthFormatted.toString())){
    //     finalarr.push(element)
    //   }
    // });
    // console.log("=====filteredData====", finalarr);

    if (sessionStorage.getItem("tabName") === "Completed Log") {
      if (
        this.permission.DeletingPermission &&
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingCompletedDeptListAddPermissionFun();
      } else if (
        this.permission.HasFullAccess ||
        this.permission.DeletingPermission ||
        this.permission.EditingPermission ||
        this.permission.ReadOnlyPermission
      ) {
        this.getFinalOffboardingList();
      } else if (
        this.permission.AddingPermission &&
        !this.permission.HasFullAccess &&
        !this.permission.DeletingPermission &&
        !this.permission.EditingPermission &&
        !this.permission.ReadOnlyPermission
      ) {
        this.getOffboardingCompletedDeptListAddPermissionFun();
      } else {
        this.getFinalOffboardingList();
      }
    }
    // this.dataSource.data = finalarr;
  }

  //onFinancialYearChange(val) {
  //  this.finYear = val.value;
  //  this.filterData();
  //}

  generateMonthsForFinancialYear(finYear: string) {
    const [startYear, endYear] = finYear.split("-");
    const months: any[] = [];
    const startMonth = 4;
    const endMonth = 12;

    for (let month = startMonth; month <= 12; month++) {
      months.push({
        value: month.toString(),
        viewValue: `${this.monthsMapping[month]}-${startYear.slice(-2)}`,
        name: `${this.monthsMapping[month]}-${startYear.slice(-2)}`,
        checked: true,
      });
    }
    for (let month = 1; month <= 3; month++) {
      months.push({
        value: month.toString(),
        viewValue: `${this.monthsMapping[month]}-${endYear.slice(-2)}`,
        name: `${this.monthsMapping[month]}-${endYear.slice(-2)}`,
        checked: true,
      });
    }

    this.monthsList = months;
  }

  onFinancialYearChange(val) {
    this.finYear = val.value;
    this.generateMonthsForFinancialYear(this.finYear);
    // this.filterData();
    this.filterRecords();
  }

  returnFilteredDataFYFun(array, filterValue, type) {
    let filterDataRes = [];
    if (filterValue) {
      filterDataRes =
        array.filter(({ FinancialYear }) => {
          return FinancialYear === filterValue;
        }) || [];
    } else {
      return (filterDataRes = array);
    }
    return filterDataRes;
  }

  onPremiumYearChangeNewTabs(value, type, uiView, tabIdxs) {
    this.finYear = value.value;
    const filterValue = value.value;

    if (type === "My Approvals" && tabIdxs === 0) {
      this.offboardingEmpListMyApproval = this.returnFilteredDataFYFun(
        this.oldOffboardingEmpListMyApproval,
        filterValue,
        type
      );
    } else if (type === "Approved" || tabIdxs === 1) {
      this.offboardingEmpListApproved = this.returnFilteredDataFYFun(
        this.oldOffboardingEmpListApproved,
        filterValue,
        type
      );
      // this.changeDetection.detectChanges();
    } else if (type === "Rejected" || tabIdxs === 2) {
      this.offboardingEmpListRejected = this.returnFilteredDataFYFun(
        this.oldOffboardingEmpListRejected,
        filterValue,
        type
      );
    } else if (type === "Inward" || tabIdxs === 3) {
      this.offboardingEmpListInWard = this.returnFilteredDataFYFun(
        this.oldOffboardingEmpListInWard,
        filterValue,
        type
      );
    }
  }

  getEmpListByPMCode() {
    // if (this.department == this.HRfbRes || this.department == this.financeRes) {
    this.dataSourceFinance.data = this.offboardingFinance;

    this.dataSource.data = this.offboardingFinal;

    for (var i = 0; i < this.offboardingFinal.length; i++) {
      this.offboardingFinal[i].HrIcon = true;
    }

    for (var i = 0; i < this.offboardingFinance.length; i++) {
      this.offboardingFinance[i].HrIcon = true;
    }
    // } else {
    //   this.dataSource.data = [];
    //   this.dataSourceFinance.data = [];
    // }

    this.empsvc.getEmpListByPMCode(this.empCode).subscribe(
      (data: Offboarding[]) => {
        let managerIconArr = data || [];

        if (this.isPM) {
          data = [...data, ...this.dataSourceHR.data];
          const key = "EmpCode";
          data = Array.from(
            new Map(data.map((item) => [item[key], item])).values()
          );
        }

        let finalInClearanceRes = [];

        if (
          this.permission.HasFullAccess ||
          this.permission.EditingPermission ||
          this.permission.ReadOnlyPermission ||
          this.isPM
        ) {
          finalInClearanceRes = data;
        }

        if (
          this.permission.DeletingPermission &&
          sessionStorage.getItem("tabName") === "In Clearance"
        ) {
          const deletedData =
            data &&
            data.filter(
              ({ FromEmp, Status }) => !(FromEmp || Status == "In Process")
              // FromEmp ||
            );
          // this.dataSourceHR.data = [...finalInClearanceRes, ...managerIconArr];
          // this.offboardingHR = [...finalInClearanceRes, ...managerIconArr];
          if (
            this.permission.HasFullAccess ||
            this.permission.EditingPermission ||
            this.permission.ReadOnlyPermission ||
            this.isPM
          ) {
            finalInClearanceRes = [...deletedData, ...finalInClearanceRes];
          } else {
            finalInClearanceRes = [...deletedData];
          }
        }

        if (
          this.permission.AddingPermission &&
          sessionStorage.getItem("tabName") === "In Clearance"
        ) {
          const addRecords =
            data &&
            data.filter(({ CreatedBy }) => {
              return Number(CreatedBy) === this.empCode;
            });
          finalInClearanceRes = [...addRecords, ...finalInClearanceRes];
          // this.offboardingHR = [...finalInClearanceRes, ...managerIconArr]
        }

        // this.dataSourceHR.data = [...finalInClearanceRes, ...managerIconArr];'
        let dataFinalized = [...finalInClearanceRes, ...managerIconArr];
        dataFinalized = Array.from(
          new Map(dataFinalized.map((item) => [item["EmpCode"], item])).values()
        );

        dataFinalized =
          dataFinalized &&
          dataFinalized.filter(({ Status }) => Status !== "Saved");

        this.offboardingHR = dataFinalized;

        if (
          !this.permission.HasFullAccess &&
          !this.permission.EditingPermission &&
          !this.permission.ReadOnlyPermission &&
          !this.permission.DeletingPermission &&
          !this.permission.AddingPermission &&
          this.isPM &&
          sessionStorage.getItem("tabName") === "In Clearance"
        ) {
          this.offboardingHR = data;
        }

        this.pmcodeList = finalInClearanceRes.filter(
          (x) => x.Status != "Saved"
        );
        // this.deptWithPM = this.pmcodeList.filter((x) => x.Status != "Saved");
        // this.dataSourceHR.data = this.pmcodeList;
        //List of employees resigned under People managers whose depts not as below
        if (
          this.pmcodeList.length != 0 &&
          this.department != "HR" &&
          this.department != "Finance" &&
          this.department != "Admin" &&
          this.department != "IT"
        ) {
          // this.codeExistsinPMList = true;
          this.deptWithPM = this.pmcodeList.filter((x) => x.Status != "Saved");
          this.pmcodeList = this.deptWithPM;
          this.dataSourceHR.data = this.pmcodeList;
          this.offboardingHR = this.dataSourceHR.data;
          // this.dataSource.data = [];
          // this.dataSourceFinance.data = [];
        }

        //Full List for dept=hr(not managers) and people in offboarding settings
        else if (
          this.pmcodeList.length == 0 &&
          (this.mailexitsIT == true || this.mailexitsAdmin == true)
        ) {
          this.codeExistsinPMList = false;
          this.deptWithoutPM = this.offboardingHR.filter(
            (x) => x.Status != "Saved"
          );
          this.offboardingHR = this.deptWithoutPM;
          this.dataSourceHR.data = this.offboardingHR;
          this.offboardingHR = this.dataSourceHR.data;
        }

        //List for being HR   --  this.department == this.HRfbRes
        else if (
          this.permission.HasFullAccess ||
          this.permission.EditingPermission ||
          this.permission.ReadOnlyPermission ||
          this.permission.DeletingPermission ||
          this.permission.AddingPermission
        ) {
          this.dataSourceHR.data = this.offboardingHR;
          this.offboardingHR = this.dataSourceHR.data;
          this.codeExistsinPMList = false;
        } else if (
          this.pmcodeList.length != 0 &&
          (this.department == "Admin" || this.department == "IT")
        ) {
          this.ITAdminWithPM = this.offboardingHR.filter(
            (x) => x.Status != "Saved"
          );
          this.offboardingHR = this.ITAdminWithPM;
          this.dataSourceHR.data = this.offboardingHR;
        }

        //List for being finance manager
        else if (this.pmcodeList.length != 0 && this.department == "Finance") {
          this.FinanceWithPM = this.pmcodeList.filter(
            (x) => x.Status != "Saved"
          );
          this.pmcodeList = this.FinanceWithPM;
          this.offboardingHR = this.pmcodeList;
          this.dataSourceHR.data = this.offboardingHR;
        }

        //First list empty
        else {
          if (this.pmcodeList.length != 0) {
            this.deptWithPM = this.pmcodeList.filter(
              (x) => x.Status != "Saved"
            );
            this.dataSourceHR.data = this.pmcodeList;
          } else {
            this.dataSourceHR.data = [];
            this.offboardingHR = this.dataSourceHR.data;
            this.codeExistsinPMList = false;
          }
        }

        var filterFinanceYearListHR = this.dataSourceHR.data.filter(
          (x) => x.FinancialYear == this.finYear
        );

        this.dataSourceHR.data = filterFinanceYearListHR;

        var filterFinanceYearListFinance = this.dataSourceFinance.data.filter(
          (x) => x.FinancialYear == this.finYear
        );
        this.dataSourceFinance.data = filterFinanceYearListFinance;
        var filterFinanceYearListFinal = this.dataSource.data.filter(
          (x) => x.FinancialYear == this.finYear
        );
        this.dataSource.data = filterFinanceYearListFinal;

        if (this.dataSourceHR.data.length == 0) {
          this.showEmptyMessageHR = "No Records Found";
          this.emptyRecordbooleanHR = true;
        } else {
          this.emptyRecordbooleanHR = false;

          this.showEmptyMessageHR = "";
        }
        if (this.dataSourceFinance.data.length == 0) {
          this.showEmptyMessageFinance = "No Records Found";
          this.emptyRecordbooleanFinance = true;
        } else {
          this.emptyRecordbooleanFinance = false;

          this.showEmptyMessageFinance = "";
        }
        if (this.dataSource.data.length == 0) {
          this.showEmptyMessage = "No Records Found";
          this.emptyRecordboolean = true;
        } else {
          this.emptyRecordboolean = false;

          this.showEmptyMessage = "";
        }
        // for (var i = 0; i < this.offboardingHR.length; i++) {
        //   if (this.pmcodeList.length != 0) {
        //     for (var j = 0; j < this.pmcodeList.length; j++) {
        //       if (this.pmcodeList[j].EmpCode == this.offboardingHR[i].EmpCode) {
        //         this.offboardingHR[i].mgrIconDept = true;
        //       }
        //     }
        //   }
        // }

        for (var i = 0; i < managerIconArr.length; i++) {
          if (managerIconArr.length != 0) {
            for (var j = 0; j < this.offboardingHR.length; j++) {
              if (managerIconArr[i].EmpCode === this.offboardingHR[j].EmpCode) {
                this.offboardingHR[j].mgrIconDept = true;
              }
            }
          }
        }

        for (var i = 0; i < this.offboardingHR.length; i++) {
          if (this.offboardingHR[i].HRFinalFeedback == true) {
            this.offboardingHR[i].disableIcon = true;
          } else this.offboardingHR[i].disableIcon = false;

          if (this.codeExistsinPMList == true) {
            this.offboardingHR[i].ManagerIcon = true;
            this.offboardingHR[i].ItIcon = false;
            this.offboardingHR[i].AdminIcon = false;
            this.offboardingHR[i].HrIcon = false;
          } else this.offboardingHR[i].ManagerIcon = false;
          if (
            this.mailexitsIT == true &&
            this.offboardingHR[i].ManagerFeedBack == true
          ) {
            // && this.codeExistsinPMList == false) {
            this.offboardingHR[i].ItIcon = true;
            this.offboardingHR[i].AdminIcon = false;
            this.offboardingHR[i].ManagerIcon = false;
            this.offboardingHR[i].HrIcon = false;
          } else this.offboardingHR[i].ItIcon = false;

          if (
            this.mailexitsAdmin == true &&
            this.offboardingHR[i].ManagerFeedBack == true
          ) {
            // && this.codeExistsinPMList == false) {
            this.offboardingHR[i].AdminIcon = true;
            this.offboardingHR[i].ManagerIcon = false;
            this.offboardingHR[i].ItIcon = false;
            this.offboardingHR[i].HrIcon = false;
          } else this.offboardingHR[i].AdminIcon = false;
          if (
            this.department == this.HRfbRes &&
            this.offboardingHR[i].ManagerFeedBack == true
          ) {
            this.offboardingHR[i].HrIcon = true;
            this.offboardingHR[i].AdminIcon = false;
            this.offboardingHR[i].ManagerIcon = false;
            this.offboardingHR[i].ItIcon = false;
          } else this.offboardingHR[i].HrIcon = false;
        }

        // if (this.dataSourceHR.data && this.dataSourceHR.data.length === 0) {
        //   this.isPMtrue = false;
        // }
      },
      (error) => {
        this.error = error;
      }
    );
  }
  getOffboardingCompletedDeptList() {
    this.empsvc.getOffboardingCompletedDeptList().subscribe(
      (data: Offboarding[]) => {
        this.offboardingDeptCompleted = data;

        this.dataSourceComplete.data = this.offboardingDeptCompleted;

        this.dataSourceComplete.paginator = this.paginatorCom;
        this.getEmpListForLastTab();
      },
      (error) => {
        this.error = error;
      }
    );
  }
  getEmpListForLastTab() {
    this.empsvc.getEmpListByPMCodeAfterHR(this.empCode).subscribe(
      (data: any[]) => {
        this.pmCodeClearanceList = data;
        if (
          this.pmCodeClearanceList &&
          this.pmCodeClearanceList.length != 0 &&
          this.department != "HR" &&
          this.department != "Finance" &&
          this.department != "Admin" &&
          this.department != "IT"
        ) {
          // if (this.department == "Admin") {
          this.pmInCompleteList = 1;
          this.dataSourceComplete.data = this.pmCodeClearanceList;
          this.offboardingDeptCompleted = this.dataSourceComplete.data;
        }

        //Full List for dept=hr(not managers) and people in offboarding settings
        else if (
          this.pmCodeClearanceList &&
          this.pmCodeClearanceList.length != 0 &&
          this.department == "IT" &&
          this.mailexitsIT == false
        ) {
          this.pmInCompleteList = 2;
          this.dataSourceComplete.data = this.pmCodeClearanceList;
          this.offboardingDeptCompleted = this.dataSourceComplete.data;
        } else if (
          this.pmCodeClearanceList &&
          this.pmCodeClearanceList.length != 0 &&
          this.department == "Admin" &&
          this.mailexitsAdmin == false
        ) {
          this.pmInCompleteList = 3;
          this.dataSourceComplete.data = this.pmCodeClearanceList;
          this.offboardingDeptCompleted = this.dataSourceComplete.data;
        } else if (
          this.pmCodeClearanceList &&
          this.pmCodeClearanceList.length != 0 &&
          this.department == "IT" &&
          this.mailexitsIT == true
        ) {
          this.pmInCompleteList = 2;
          this.dataSourceComplete.data = this.offboardingDeptCompleted;
          this.offboardingDeptCompleted = this.dataSourceComplete.data;
        } else if (
          this.pmCodeClearanceList &&
          this.pmCodeClearanceList.length != 0 &&
          this.department == "Admin" &&
          this.mailexitsAdmin == true
        ) {
          this.pmInCompleteList = 3;
          this.dataSourceComplete.data = this.offboardingDeptCompleted;
          this.offboardingDeptCompleted = this.dataSourceComplete.data;
        } else if (
          this.pmCodeClearanceList &&
          this.pmCodeClearanceList.length == 0 &&
          this.mailexitsIT == true
        ) {
          this.pmInCompleteList = 2;
          this.dataSourceComplete.data = this.offboardingDeptCompleted;
          this.offboardingDeptCompleted = this.dataSourceComplete.data;
        } else if (
          this.pmCodeClearanceList &&
          this.pmCodeClearanceList.length == 0 &&
          this.mailexitsAdmin == true
        ) {
          this.pmInCompleteList = 3;
          this.dataSourceComplete.data = this.offboardingDeptCompleted;
          this.offboardingDeptCompleted = this.dataSourceComplete.data;
        }

        //First list empty
        else {
          this.dataSourceComplete.data = [];
          this.offboardingDeptCompleted = this.dataSourceComplete.data;
        }
        var filterFinanceYearList = this.dataSourceComplete.data.filter(
          (x) => x.FinancialYear == this.finYear
        );
        this.dataSourceComplete.data = filterFinanceYearList;
        if (this.dataSourceComplete.data.length == 0) {
          this.showEmptyMessageComplete = "No Records Found";
          this.emptyRecordbooleanComplete = true;
        } else {
          this.emptyRecordbooleanComplete = false;

          this.showEmptyMessageComplete = "";
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }
  getIconData(code: any) {
    if (this.pmInCompleteList == 1) {
      this.feedbackType = "Manager";
      this.router.navigateByUrl(
        "/offboardingfeedback/" + this.feedbackType + "/" + code
      );
    } else if (this.pmInCompleteList == 2) {
      this.feedbackType = "IT";
      this.router.navigateByUrl(
        "/offboardingfeedback/" + this.feedbackType + "/" + code
      );
    } else if (this.pmInCompleteList == 3) {
      this.feedbackType = "Admin";
      this.router.navigateByUrl(
        "/offboardingfeedback/" + this.feedbackType + "/" + code
      );
    }
    this.empsvc
      .getOffboardingFeedbackTypeDescription(this.feedbackType, code)
      .subscribe((data: any[]) => {
        this.completedcheckList = data;
      });
  }
  getAllContacts() {
    this.empsvc.getAllContacts().subscribe(
      (data: any) => {
        this.contactList = data;
        for (var i = 0; i < this.contactList.length; i++) {
          if (
            this.contactList[i].Contacts.toLowerCase() ==
              this.email.toLowerCase() &&
            this.contactList[i].FeedbackTypeId == "IT"
          ) {
            this.mailexitsIT = true;
            break;
          } else this.mailexitsIT = false;
        }
        for (var i = 0; i < this.contactList.length; i++) {
          if (
            this.contactList[i].Contacts.toLowerCase() ==
              this.email.toLowerCase() &&
            this.contactList[i].FeedbackTypeId == "Admin"
          ) {
            this.mailexitsAdmin = true;
            break;
          } else this.mailexitsAdmin = false;
        }
      },
      (error) => (this.error = error)
    );
  }

  getOffboardingdetailsbyCode() {
    this.empsvc.getOffboardingDetails(this.empCode).subscribe(
      (data: any) => {
        this.offboardingdetails = data;
      },
      (error) => (this.error = error)
    );
  }

  returnFilteredDataFun(array, filterValue, type) {
    let filterDataRes = [];
    if (filterValue) {
      filterDataRes =
        array.filter(({ Name, EmpCode }) => {
          return (
            (Name && Name.trim().toLowerCase().startsWith(filterValue)) ||
            (EmpCode && EmpCode.toString().startsWith(filterValue))
          );
        }) || [];
    } else {
      return (filterDataRes = array);
    }
    return filterDataRes;
  }

  searchRecordsFromList(value, type, uiView, tabIdxs) {
    const filterValue = value.toString().trim().toLowerCase();
    if (tabIdxs === 0) {
      this.offboardingEmpListMyApproval = this.returnFilteredDataFun(
        this.oldOffboardingEmpListMyApproval,
        filterValue,
        type
      );
      this.totalCount = this.offboardingEmpListMyApproval.length;
    } else if (tabIdxs === 1) {
      this.offboardingEmpListApproved = this.returnFilteredDataFun(
        this.oldOffboardingEmpListApproved,
        filterValue,
        type
      );
      this.totalCount = this.offboardingEmpListApproved.length;
    } else if (tabIdxs === 2) {
      this.offboardingEmpListRejected = this.returnFilteredDataFun(
        this.oldOffboardingEmpListRejected,
        filterValue,
        type
      );
      this.totalCount = this.offboardingEmpListRejected.length;
    } else if (tabIdxs === 3) {
      this.offboardingEmpListInWard = this.returnFilteredDataFun(
        this.oldOffboardingEmpListInWard,
        filterValue,
        type
      );
      this.totalCount = this.offboardingEmpListInWard.length;
    }
  }

  parentFun() {
    this.getOffboardingQueueDetailsFun(false);
  }

  getOffboardingQueueDetailsFun(isInitialLoad) {
    this.empsvc.getOffboardingQueueDetails(this.empCode).subscribe(
      (data: any) => {
        data = data.map((item) => {
          return {
            ...item,
            ResignationDate:
              item.ResignationDate &&
              new Date(item.ResignationDate).toISOString().split("T")[0],
          };
        });

        this.offboardingEmpListMyApproval = data.filter(
          ({ Status }) => Status === "Submitted"
        );
        this.oldOffboardingEmpListMyApproval = data.filter(
          ({ Status }) => Status === "Submitted"
        );
        this.offboardingEmpListApproved = data.filter(
          ({ IsManagerApprReject }) => IsManagerApprReject === true
        );

        this.oldOffboardingEmpListApproved = data.filter(
          ({ IsManagerApprReject }) => IsManagerApprReject === true
        );

        this.offboardingEmpListRejected = data.filter(
          ({ IsManagerApprReject }) => IsManagerApprReject === false
        );

        this.oldOffboardingEmpListRejected = data.filter(
          ({ IsManagerApprReject }) => IsManagerApprReject === false
        );

        //this.offboardingEmpListApproved = data.filter(
        //  ({ Status, Designation }) => ["Approved"].includes(Status)
        //);
        //this.oldOffboardingEmpListApproved = data.filter(
        //  ({ Status, Designation }) => ["Approved"].includes(Status)
        //);

        //this.offboardingEmpListRejected = data.filter(
        //  ({ Status, Designation }) => ["Rejected"].includes(Status)
        //);
        //this.oldOffboardingEmpListRejected = data.filter(
        //  ({ Status, Designation }) => ["Rejected"].includes(Status)
        //);
        if (isInitialLoad) {
          this.totalCount = this.offboardingEmpListMyApproval.length;
        }
      },
      (error) => (this.error = error)
    );
  }

  getStatus(item) {
    if (item.Status === "Rejected") {
      if (item.Designation === "manager") {
        item.Status = "Rejected (Manager)";
      } else if (item.Designation === "HR") {
        item.Status = "Rejected (HR)";
      }
    }

    if (item.Status === "Revoked") {
      if (item.HRResignationComments) {
        item.Status = "Revoked (HR)";
      } else if (item.ManagerResignationComments) {
        item.Status = "Revoked (Manager)";
      } else {
        item.Status = "Revoked (Employee)";
      }
    }
    return item.Status;
  }

  getOffboardingInwardDetailsFun() {
    this.empsvc.getOffboardingInwardDetails(this.empCode).subscribe(
      (data: any) => {
        if (data != null) {
          data = data.map((item) => {
            return {
              ...item,
              ResignationDate:
                item.ResignationDate &&
                new Date(item.ResignationDate).toISOString().split("T")[0],
            };
          });
        }
        this.offboardingEmpListInWard = data.filter(
          (details) => details.Status !== this.hrStatus.Save
        );
        this.oldOffboardingEmpListInWard = data.filter(
          (details) => details.Status !== this.hrStatus.Save
        );
      },
      (error) => (this.error = error)
    );
  }

  getAllOffboardingQueueDetailsFunForHR() {
    this.getHrQueueDetails();
  }

  //getAllOffboardingdetails() {
  //  this.empsvc.getAllOffboardingDetails().subscribe(
  //    (data: any[]) => {
  //      this.originalDataSourceAll = data;
  //      this.filterRecords();
  //      this.excelDetails = data;
  //    },
  //    (error) => (this.error = error)
  //  );
  //}

  getEmployeeName(empcode) {
    return new Promise((resolve, reject) => {
      this.empsvc.getEmployeeName(empcode).subscribe(
        (data: any) => {
          this.name = data; // Set the name
          resolve(); // Resolve the promise
        },
        (error) => {
          this.error = error;
          reject(error); // Reject the promise
        }
      );
    });
  }

  exportToExcelHR() {
    this.datePipe = new DatePipe("en-US");
    var offboarding = [...this.dataSourceQueue.data];
    this.empsvc.getAllExcelOffboardingDetails(offboarding).subscribe(
      (data: Offboarding[]) => {
        this.excelDetails = data;
        if (this.excelDetails != null) {
          let { sheetName, fileName } = getFileName(name);

          var wb = xlsx.utils.book_new();
          var ws = xlsx.utils.json_to_sheet(this.excelDetails);
          xlsx.utils.book_append_sheet(wb, ws, sheetName);
          xlsx.writeFile(wb, `${fileName}.xlsx`);
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getHrQueueDetails() {
    this.loader = true;
    if (
      this.permission.AddingPermission &&
      !this.permission.HasFullAccess &&
      !this.permission.DeletingPermission &&
      !this.permission.EditingPermission &&
      !this.permission.ReadOnlyPermission
    ) {
      return this.empsvc
        .getAddPermissionOffBoardingList(this.empCode)
        .toPromise()
        .then(
          (data: Offboarding[]) => {
            let arr = [];
            data &&
              data.map((item) => {
                if (item.Status === "Rejected") {
                  if (item.Designation === "Manager") {
                    item.Status = "Rejected (Manager)";
                  } else if (item.Designation === "HR") {
                    item.Status = "Rejected (HR)";
                  }
                }

                if (item.Status === "Revoked") {
                  if (item.HRResignationComments) {
                    item.Status = "Revoked (HR)";
                  } else if (item.ManagerResignationComments) {
                    item.Status = "Revoked (Manager)";
                  } else {
                    item.Status = "Revoked (Employee)";
                  }
                }

                const resignationDate = item.ResignationDate
                  ? new Date(item.ResignationDate)
                  : null;
                const monthNumber = resignationDate
                  ? (resignationDate.getMonth() + 1).toString()
                  : null;

                //item.isThumbVisible =
                //  (item.Status === "Saved" ||
                //    item.Status === "Initiated" ||
                //    item.Status === "In Process" ||
                //    item.Status === "Completed" ||
                //    item.Status === "Submitted to Finance") &&
                //  (!item.LastWorkingDay ||
                //    new Date(item.LastWorkingDay) >= new Date());

                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);

                let lwdDate = null;
                if (item.LastWorkingDay) {
                  lwdDate = new Date(item.LastWorkingDay);
                  lwdDate.setHours(0, 0, 0, 0);
                }

                item.isThumbVisible =
                  (item.Status === "Saved" ||
                    item.Status === "Initiated" ||
                    item.Status === "In Process" ||
                    item.Status === "Completed" ||
                    item.Status === "Submitted to Finance") &&
                  (!lwdDate || lwdDate >= currentDate);

                if (item.IsEmpFeedbackRequired) {
                  item.isThumbVisible =
                    item.Status === "Saved" ||
                    item.Status === "Initiated" ||
                    item.Status === "In Process" ||
                    item.Status === "Completed";
                  item.isThumbDisabled = true;
                } else if (
                  !item.IsEmpFeedbackRequired &&
                  item.LastWorkingDay &&
                  new Date(item.LastWorkingDay) < new Date()
                ) {
                  item.isThumbVisible = false;
                }

                arr.push({
                  ...item,
                  ResignationDate:
                    item.ResignationDate &&
                    new Date(item.ResignationDate).toISOString().split("T")[0],
                  MonthName: monthNumber
                    ? this.monthsMapping[monthNumber]
                    : null,
                });
              });

            let filteredData = arr.filter(
              ({ Status, FromEmp, finalStatus }) => {
                return (
                  (Status == "Saved" &&
                    FromEmp &&
                    finalStatus == "Confirmed") ||
                  !(Status == "Saved" && FromEmp)
                );
              }
            );

            this.HrQueueDetails = filteredData || [];
            this.dataSourceQueue.data = filteredData || [];
            this.originalDataSourceAll = filteredData || [];
            this.dataSourceQueue.paginator = this.paginatorAll;
            this.dataSourceQueue.sort = this.sortQueue;
            var result = this.sortList(filteredData);
            this.dataSourceQueue = new MatTableDataSource(result);
            this.totalItems = this.dataSourceQueue.data.length;
            this.loader = false;

            filteredData = filteredData.filter(
              ({ Status, FromEmp, finalStatus }) => {
                return (
                  (Status == "Saved" &&
                    FromEmp &&
                    finalStatus == "Confirmed") ||
                  !(Status == "Saved" && FromEmp) ||
                  !(Status == "Saved" && finalStatus == "Saved" && FromEmp)
                );
              }
            );

            if (this.finYear && this.finYear !== "All") {
              filteredData = filteredData.filter(
                (x) => x.FinancialYear === this.finYear
              );
              const resignationYear = (emp) =>
                emp.ResignationDate
                  ? new Date(emp.ResignationDate).getFullYear()
                  : null;
              const lwdYear = (emp) =>
                emp.LastWorkingDay
                  ? new Date(emp.LastWorkingDay).getFullYear()
                  : null;

              filteredData = filteredData.filter(
                (emp) =>
                  resignationYear(emp) === parseInt(this.finYear) ||
                  lwdYear(emp) === parseInt(this.finYear)
              );
            }

            if (this.resgntypeResult && this.resgntypeResult.length < 2) {
              filteredData = filteredData.filter(
                (emp) =>
                  emp.ExitID != null &&
                  this.resgntypeResult.includes(emp.ExitID)
              );
            }

            filteredData = filteredData.map((emp) => {
              if (emp.Status === "Rejected") {
                emp.Status =
                  emp.Designation === "Manager"
                    ? "Rejected (Manager)"
                    : "Rejected (HR)";
              } else if (emp.Status === "Revoked") {
                emp.Status = emp.HRResignationComments
                  ? "Revoked (HR)"
                  : emp.ManagerResignationComments
                  ? "Revoked (Manager)"
                  : "Revoked (Employee)";
              }
              return emp;
            });

            if (
              (this.statusList && this.statusList.length) !==
                (this.statusResult && this.statusResult.length) &&
              this.statusResult &&
              this.statusResult.length > 0
            ) {
              filteredData = filteredData.filter(
                (emp) => emp.Status && this.statusResult.includes(emp.Status)
              );
            }

            if (this.DateResult && this.selectedMonth.length < 2) {
              filteredData = filteredData.filter((emp) => {
                const resignationDateMonth = emp.ResignationDate
                  ? new Date(emp.ResignationDate).getMonth() + 1
                  : null;
                const lwdMonth = emp.LastWorkingDay
                  ? new Date(emp.LastWorkingDay).getMonth() + 1
                  : null;

                return (
                  (this.DateResult.includes("Resignation Date") &&
                    resignationDateMonth !== null &&
                    this.selectedMonth.includes(
                      resignationDateMonth.toString()
                    )) ||
                  (this.DateResult.includes("Confirmed LWD") &&
                    lwdMonth !== null &&
                    this.selectedMonth.includes(lwdMonth.toString()))
                );
              });
            }

            if (this.search) {
              filteredData = filteredData.filter(
                (res) =>
                  (res.Name &&
                    res.Name.toLowerCase().includes(
                      this.removeExtraSpaces(this.search.toLowerCase())
                    )) ||
                  res.EmpCode.toString().includes(this.search.toLowerCase())
              );
            }

            if (
              (!this.resgntypeResult || this.resgntypeResult.length === 0) &&
              (!this.statusResult || this.statusResult.length === 0) &&
              !this.search
            ) {
              filteredData = [];
            }

            this.dataSourceQueue.data = filteredData;
            this.updateCount();

            return filteredData;
          },
          (error) => {
            this.error = error;
            this.loader = false;
          }
        );
    } else {
      return this.empsvc
        .getOffboardingQueueDetails(null)
        .toPromise()
        .then(
          (data: Offboarding[]) => {
            let arr = [];
            data &&
              data.map((item) => {
                if (item.Status === "Rejected") {
                  if (item.Designation === "Manager") {
                    item.Status = "Rejected (Manager)";
                  } else if (item.Designation === "HR") {
                    item.Status = "Rejected (HR)";
                  }
                }

                if (item.Status === "Revoked") {
                  if (item.HRResignationComments) {
                    item.Status = "Revoked (HR)";
                  } else if (item.ManagerResignationComments) {
                    item.Status = "Revoked (Manager)";
                  } else {
                    item.Status = "Revoked (Employee)";
                  }
                }

                const resignationDate = item.ResignationDate
                  ? new Date(item.ResignationDate)
                  : null;
                const monthNumber = resignationDate
                  ? (resignationDate.getMonth() + 1).toString()
                  : null;

                //item.isThumbVisible =
                //  (item.Status === "Saved" ||
                //    item.Status === "Initiated" ||
                //    item.Status === "In Process" ||
                //    item.Status === "Completed" ||
                //    item.Status === "Submitted to Finance") &&
                //  (!item.LastWorkingDay ||
                //    new Date(item.LastWorkingDay) > new Date());

                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);

                let lwdDate = null;
                if (item.LastWorkingDay) {
                  lwdDate = new Date(item.LastWorkingDay);
                  lwdDate.setHours(0, 0, 0, 0);
                }

                item.isThumbVisible =
                  (item.Status === "Saved" ||
                    item.Status === "Initiated" ||
                    item.Status === "In Process" ||
                    item.Status === "Completed" ||
                    item.Status === "Submitted to Finance") &&
                  (!lwdDate || lwdDate >= currentDate);

                if (item.IsEmpFeedbackRequired) {
                  item.isThumbVisible =
                    item.Status === "Saved" ||
                    item.Status === "Initiated" ||
                    item.Status === "In Process" ||
                    item.Status === "Completed";
                  item.isThumbDisabled = true;
                } else if (
                  !item.IsEmpFeedbackRequired &&
                  lwdDate &&
                  lwdDate < currentDate
                ) {
                  item.isThumbVisible = false;
                }

                arr.push({
                  ...item,
                  ResignationDate:
                    item.ResignationDate &&
                    new Date(item.ResignationDate).toISOString().split("T")[0],
                  MonthName: monthNumber
                    ? this.monthsMapping[monthNumber]
                    : null,
                });
              });

            let filteredData = arr.filter(
              ({ Status, FromEmp, finalStatus }) => {
                return (
                  (Status == "Saved" &&
                    FromEmp &&
                    finalStatus == "Confirmed") ||
                  !(Status == "Saved" && FromEmp)
                );
              }
            );

            let finalRes = [];
            if (
              this.permission.DeletingPermission &&
              sessionStorage.getItem("tabName") === "Listing"
            ) {
              finalRes =
                filteredData &&
                filteredData.filter(
                  ({ FromEmp, Status }) =>
                    !(FromEmp || (Status !== "Saved" && Status !== "Initiated"))
                );
            }
            if (
              this.permission.AddingPermission &&
              sessionStorage.getItem("tabName") === "Listing"
            ) {
              const addRecords =
                filteredData &&
                filteredData.filter(({ CreatedBy }) => {
                  return Number(CreatedBy) === this.empCode;
                });
              finalRes = [...addRecords, ...finalRes];
            }

            if (
              this.permission.HasFullAccess ||
              this.permission.EditingPermission ||
              this.permission.ReadOnlyPermission
            ) {
              finalRes = filteredData;
            }

            this.HrQueueDetails = finalRes || filteredData || [];
            this.dataSourceQueue.data = finalRes || filteredData || [];
            this.originalDataSourceAll = finalRes || filteredData || [];
            this.dataSourceQueue.paginator = this.paginatorAll;
            this.dataSourceQueue.sort = this.sortQueue;
            var result = this.sortList(finalRes || filteredData);
            this.dataSourceQueue = new MatTableDataSource(result);
            this.totalItems = this.dataSourceQueue.data.length;
            this.loader = false;
            this.statusResult = this.statusList
              .filter((status) => status.checked === true)
              .map((status) => status.value);
            this.filterRecords();
          },
          (error) => {
            this.error = error;
            this.loader = false;
          }
        );
    }
  }

  toggleResgnType() {
    if (this.selectedAllTypes) {
      this.resgntype.options.forEach((item: MatOption) => item.select());
    } else {
      this.resgntype.options.forEach((item: MatOption) => item.deselect());
    }
  }

  changeResgnType() {
    let newStatus = true;
    this.resgntype.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.selectedAllTypes = newStatus;
  }

  toggleAllSelection() {
    if (this.selectedAllStatus) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }

  changeStatus() {
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.selectedAllStatus = newStatus;
  }

  toggleAllDates() {
    if (this.selectedAllDates) {
      this.date.options.forEach((item: MatOption) => item.select());
    } else {
      this.date.options.forEach((item: MatOption) => item.deselect());
    }
  }

  changeDates() {
    let newStatus = true;
    this.date.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.selectedAllDates = newStatus;
  }

  sortList(list) {
    let results = [];
    if (list != null) {
      var data = list;
      if (data != undefined) {
        data = data.sort((a, b) => {
          return compare(a.ConfirmedLWD, b.ConfirmedLWD, true);
        });
        data.forEach((res) => results.push(res));
      }
    }
    this.lstData = results;
    return results;
  }

  sortData(sort: Sort): void {
    this.lstData = this.dataSourceQueue.data;
    let data = this.lstData.slice();
    if (!sort.active || sort.direction == "") {
      this.dataSourceQueue = new MatTableDataSource(data);
      this.dataSourceQueue.paginator = this.paginatorAll;
      this.dataSourceQueue.sort = this.sortQueue;
      return;
    }

    this.dataSourceQueue = new MatTableDataSource(
      data.sort((a, b) => {
        let isdesc = sort.direction == "desc";
        switch (sort.active) {
          case "EmpCode":
            return compare(a.EmpCode, b.EmpCode, isdesc);
          case "Name":
            return compare(a.Name, b.Name, isdesc);
          case "Location":
            return compare(a.LocationName, b.LocationName, isdesc);
          case "ResignationDate":
            return compare(a.ResignationDate, b.ResignationDate, isdesc);
          case "ResignationType":
            return compare(a.ExitID, b.ExitID, isdesc);
          case "IndicativeLWD":
            return compare(a.IndicativeLWD, b.IndicativeLWD, isdesc);
          case "ConfirmedLWD":
            return compare(a.LastWorkingDay, b.LastWorkingDay, !isdesc);
          case "Manager":
            return compare(a.To, b.To, isdesc);
          case "Status":
            return compare(a.Status, b.Status, isdesc);
          default:
            return 0;
        }
      })
    );
    this.dataSourceQueue.paginator = this.paginatorAll;
    this.dataSourceQueue.sort = this.sortQueue;
  }

  updateCount() {
    const checkedStatuses = this.statusList
      .filter((status) => status.checked === true)
      .map((status) => status.value);

    // Count based on the filtered data
    this.count = this.dataSourceQueue.data.filter((emp) =>
      checkedStatuses.includes(emp.Status)
    ).length;
  }

  filterRecords() {
    let filteredData = this.filterData();
    this.dataSourceQueue = new MatTableDataSource(this.sortList(filteredData));
    this.totalItems = this.dataSourceQueue.data.length;
    this.dataSourceQueue.paginator = this.paginatorAll;
  }

  filterData() {
    let data =
      this.originalDataSourceAll != null &&
      this.originalDataSourceAll.length > 0
        ? this.originalDataSourceAll
        : [];
    let filteredData = [...data];

    filteredData = filteredData.filter(({ Status, FromEmp, finalStatus }) => {
      return (
        (Status == "Saved" && FromEmp && finalStatus == "Confirmed") ||
        !(Status == "Saved" && FromEmp) ||
        !(Status == "Saved" && finalStatus == "Saved" && FromEmp)
      );
    });

    if (this.finYear && this.finYear !== "All") {
      filteredData = filteredData.filter(
        (x) => x.FinancialYear === this.finYear
      );
      const resignationYear = (emp) =>
        emp.ResignationDate
          ? new Date(emp.ResignationDate).getFullYear()
          : null;
      const lwdYear = (emp) =>
        emp.LastWorkingDay ? new Date(emp.LastWorkingDay).getFullYear() : null;

      filteredData = filteredData.filter(
        (emp) =>
          resignationYear(emp) === parseInt(this.finYear) ||
          lwdYear(emp) === parseInt(this.finYear)
      );
    }

    if (this.resgntypeResult && this.resgntypeResult.length < 2) {
      filteredData = filteredData.filter(
        (emp) => emp.ExitID != null && this.resgntypeResult.includes(emp.ExitID)
      );
    }

    filteredData = filteredData.map((emp) => {
      if (emp.Status === "Rejected") {
        emp.Status =
          emp.Designation === "Manager"
            ? "Rejected (Manager)"
            : "Rejected (HR)";
      } else if (emp.Status === "Revoked") {
        emp.Status = emp.HRResignationComments
          ? "Revoked (HR)"
          : emp.ManagerResignationComments
          ? "Revoked (Manager)"
          : "Revoked (Employee)";
      }
      return emp;
    });

    if (
      (this.statusList && this.statusList.length) !==
        (this.statusResult && this.statusResult.length) &&
      this.statusResult &&
      this.statusResult.length > 0
    ) {
      filteredData = filteredData.filter(
        (emp) => emp.Status && this.statusResult.includes(emp.Status)
      );
    }

    if (this.DateResult && this.selectedMonth.length > 0) {
      filteredData = filteredData.filter((emp) => {
        const resignationDateMonth = emp.ResignationDate
          ? new Date(emp.ResignationDate).getMonth() + 1
          : null;
        const lwdMonth = emp.LastWorkingDay
          ? new Date(emp.LastWorkingDay).getMonth() + 1
          : null;

        return (
          (this.DateResult.includes("Resignation Date") &&
            resignationDateMonth !== null &&
            this.selectedMonth.includes(resignationDateMonth.toString())) ||
          (this.DateResult.includes("Confirmed LWD") &&
            lwdMonth !== null &&
            this.selectedMonth.includes(lwdMonth.toString()))
        );
      });
    }

    if (this.search) {
      filteredData = filteredData.filter(
        (res) =>
          (res.Name &&
            res.Name.toLowerCase().includes(
              this.removeExtraSpaces(this.search.toLowerCase())
            )) ||
          res.EmpCode.toString().includes(this.search.toLowerCase())
      );
    }

    if (
      ((!this.resgntypeResult || this.resgntypeResult.length === 0) &&
        (!this.statusResult || this.statusResult.length === 0) &&
        !this.search) ||
      this.selectedMonth.length === 0
    ) {
      filteredData = [];
    }

    if (
      this.statusResult == null ||
      this.statusResult.length == 0 ||
      this.statusResult.length < 0 ||
      this.DateResult == null ||
      this.DateResult.length == 0 ||
      this.DateResult.length < 0
    ) {
      filteredData = [];
    }

    this.dataSourceQueue.data = filteredData;
    this.updateCount();

    return filteredData;
  }

  ngOnDestroy() {
    this.resetFilter();
  }

  resetFilter() {
    this.getHrQueueDetails()
      .then(() => this.getExitReasons())
      .then(() => {
        this.initializeSelections();
      });
    this.search = null;
    this.DatesList = [
      {
        value: "Resignation Date",
        viewValue: "Resignation Date",
        name: "Resignation Date",
        checked: true,
      },
      {
        value: "Confirmed LWD",
        viewValue: "Confirmed LWD",
        name: "Confirmed LWD",
        checked: true,
      },
    ];
    this.statusList = [
      { value: "Saved", viewValue: "Saved", name: "Saved", checked: true },
      {
        value: "Submitted",
        viewValue: "Submitted",
        name: "Submitted",
        checked: true,
      },
      {
        value: "Approved",
        viewValue: "Approved",
        name: "Approved",
        checked: true,
      },
      {
        value: "Initiated",
        viewValue: "Initiated",
        name: "Initiated",
        checked: true,
      },
      {
        value: "Submitted to Finance",
        viewValue: "Submitted to Finance",
        name: "Submitted to Finance",
        checked: false,
      },
      {
        value: "In Process",
        viewValue: "In Process",
        name: "In Process",
        checked: false,
      },
      {
        value: "Completed",
        viewValue: "Completed",
        name: "Completed",
        checked: false,
      },
      {
        value: "Rejected (HR)",
        viewValue: "Rejected (HR)",
        name: "Rejected (HR)",
        checked: false,
      },
      {
        value: "Rejected (Manager)",
        viewValue: "Rejected (Manager)",
        name: "Rejected (Manager)",
        checked: false,
      },
      {
        value: "Revoked (Employee)",
        viewValue: "Revoked (Employee)",
        name: "Revoked (Employee)",
        checked: false,
      },
      {
        value: "Revoked (HR)",
        viewValue: "Revoked (HR)",
        name: "Revoked (HR)",
        checked: false,
      },
      {
        value: "Revoked (Manager)",
        viewValue: "Revoked (Manager)",
        name: "Revoked (Manager)",
        checked: false,
      },
    ];
    this.monthsList = [
      ...Object.keys(this.monthsMapping).map((key) => ({
        value: key,
        viewValue: this.monthsMapping[key],
        name: this.monthsMapping[key],
        checked: true,
      })),
    ];
    this.generateMonthsForFinancialYear(this.finYear);
    this.loadFinancialYears();
    this.filterRecords();
    this.dataSourceQueue = new MatTableDataSource(
      this.sortList(this.originalDataSourceAll)
    );
    this.totalItems = this.dataSourceQueue.data.length;
    this.dataSourceQueue.paginator = this.paginatorAll;
  }

  removeExtraSpaces(str) {
    return str.replace(/\s+/g, "").trim();
  }
}

const getFileName = (name: string) => {
  let timeSpan = new Date().toISOString();
  let sheetName = name || "ExportResult-Offboarding";
  let fileName = `${sheetName}-${timeSpan}`;
  return {
    sheetName,
    fileName,
  };
};

function compare(a, b, isdesc) {
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }

  if (a === b) return 0;

  if (isdesc) return a < b ? 1 : -1;
  else return a < b ? -1 : 1;
}
